<template>
  <!-- banner topo -->
  <section v-if="bannerTopo != ''" class="hero-wrap hero-wrap-2"
    :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="col-md-9 pb-5">
          <h1 class="mb-0 bread">{{ bannerTopo[0].itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- Politicas e termos -->
  <!-- Politicas e termos -->
  <section style="padding-top: 80px; padding-bottom: 80px;">
    <div class="section">
      <div class="container">
        <div class="row">
          <!-- Menu de Políticas -->
          <div class="col-lg-3 col-md-6 col-sm-8">
            <div>
              <h4 class="titulo-politicas-menu">Informações</h4>
              <ul class="menu-politicas menu">
                <li v-for="(menu, menuIndex) in informacoes" :key="menuIndex">
                  <a href="#" @click.prevent="carregaTexto(menu.itiId)">{{ menu.itiNome }}</a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Conteúdo -->
          <div class="col-lg-9 order-1 order-lg-2" v-if="informacao != ''">
            <h2 class="titulo-politicas">{{ informacao[0].itiNome }}</h2><br />
            <p v-html="informacao[0].itiResumo1"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- politicas e termos final -->

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { useRoute } from 'vue-router';

export default {
  name: 'InformacoesView',
  components: {

  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    informacoes: [],
    informacao: [],

  }),
  methods: {
    carregaMetas(texto, titulo) {
      useHead({
        title: titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    carregaTexto(value) {
      this.informacao = this.informacoes.filter(x => x.itiId == value)
    },

  },
  created() {
    this.carregaMetas("","Informações - Performance Elevadores");

    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/17/informacoesgeraistopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    axios.get('/Process/InsInstitucional/institucional/18/informacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        if (this.id) {
          this.carregaTexto(this.id);
        }
        else {
          this.carregaTexto(this.informacoes[0].itiId);
        }
      })
      .catch(error => {
        console.error(error);
      });

  }

}
</script>

<style scoped></style>